import { all, takeLatest, call, put } from 'redux-saga/effects';
import { CurrenciesInstance } from '@/services/country-information/currencies';
import { fetchCurrenciesActions } from '@/redux/actions/country-information/currencies';

export function* fetchCurrenciesSaga() {
  try {
    const { data, paging, status } = yield call(CurrenciesInstance.fetchCurrencies);
    yield put(fetchCurrenciesActions.success(data, paging, status));
  } catch (err) {
    yield put(fetchCurrenciesActions.failure(err));
  }
}

export default function* root() {
  yield all([takeLatest(fetchCurrenciesActions.request.type, fetchCurrenciesSaga)]);
}
